"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBusinessesResponseToJSON = exports.GetBusinessesResponseFromJSONTyped = exports.GetBusinessesResponseFromJSON = exports.instanceOfGetBusinessesResponse = void 0;
var runtime_1 = require("../runtime");
var BusinessResponse_1 = require("./BusinessResponse");
/**
 * Check if a given object implements the GetBusinessesResponse interface.
 */
function instanceOfGetBusinessesResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetBusinessesResponse = instanceOfGetBusinessesResponse;
function GetBusinessesResponseFromJSON(json) {
    return GetBusinessesResponseFromJSONTyped(json, false);
}
exports.GetBusinessesResponseFromJSON = GetBusinessesResponseFromJSON;
function GetBusinessesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'businesses': !(0, runtime_1.exists)(json, 'businesses') ? undefined : (json['businesses'].map(BusinessResponse_1.BusinessResponseFromJSON)),
    };
}
exports.GetBusinessesResponseFromJSONTyped = GetBusinessesResponseFromJSONTyped;
function GetBusinessesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'businesses': value.businesses === undefined ? undefined : (value.businesses.map(BusinessResponse_1.BusinessResponseToJSON)),
    };
}
exports.GetBusinessesResponseToJSON = GetBusinessesResponseToJSON;
